import attract1 from "../../img/people.jpg";
import attract2 from "../../img/attraction1.jpg";
import attract3 from "../../img/attraction2.jpg";
import attract4 from "../../img/attraction3.jpg";
import attract5 from "../../img/attraction4.jpg";
import attract6 from "../../img/attraction5.jpg";
import attract7 from "../../img/attraction6.jpg";

export const tourList = [
  {
    id: 1,
    img: `${attract1}`,
    location: "phi phi island",
    reviews: "300 reviews",
    distance: "1KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 2,
    img: `${attract2}`,
    location: "Prayer Temple",
    reviews: "100 reviews",
    distance: "4KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 3,
    img: `${attract3}`,
    location: "Royal Palace Grand",
    reviews: "128 reviews",
    distance: "0.5KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 4,
    img: `${attract4}`,
    location: "phi phi island",
    reviews: "55reviews",
    distance: "1.2KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 5,
    img: `${attract5}`,
    location: "phi phi island",
    reviews: "99 reviews",
    distance: "2.5KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 6,
    img: `${attract6}`,
    location: "phi phi island",
    reviews: "230 reviews",
    distance: "10KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
  {
    id: 7,
    img: `${attract7}`,
    location: "phi phi island",
    reviews: "528 reviews",
    distance: "6KM AWAY",
    desc:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid repudiandae harum reprehenderit consequatur dolorum quis earum officiis.",
  },
];
